import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['projectInfo', 'bidInfo'],
  data() {
    return {
      massifTypeArr: []
    };
  },
  created() {
    const obj = {
      MASSIF_TYPE: 'massifTypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
    landArr () {
      if (this.bidInfo) {
        const lands = this.bidInfo.detail.map(item => {
          item = {
            ...item,
            ...JSON.parse(item.assetsInfo)
          };
          return item;
        });
        console.log(lands);
        return lands;
      } else if (this.projectInfo) {
        const lands = JSON.parse(this.projectInfo.assetsInfo).map(item => {
          item = JSON.parse(item);
          return item;
        });
        return lands;
      } else {
        return [];
      }
    }
  },
  methods: {
  }
};
